import { useCallback } from 'react';
import { useVeloClient, GridAppLayout } from '@wix/velo-client';
import type { VeloCode, VeloCodeUpdate } from '@wix/anyide-cli-file-structure';
import { useProjectModel } from '../../model.js';
import { loadProjectRootFiles } from '../../velo.js';

export function useVelo() {
  const { model } = useProjectModel();
  const veloClient = useVeloClient();

  const createMutableApp = useCallback(
    async (code: VeloCode) => {
      const rootFiles = await loadProjectRootFiles(model.projectFolder);

      return veloClient.createMutableApp({
        ...code,
        files: code.files.concat(rootFiles),
        layout: GridAppLayout[code.layout],
      });
    },
    [model.projectFolder, veloClient]
  );

  const updateAppFiles = useCallback(
    (appId: string, codeUpdate: VeloCodeUpdate) => {
      return veloClient.updateAppFiles(appId, {
        ...codeUpdate,
        layout: GridAppLayout[codeUpdate.layout],
      });
    },
    [veloClient]
  );

  return { createMutableApp, updateAppFiles };
}
